import { isNanChecker } from "./isNanChecker";

export const getPercentageOfCommonCount = (
  commonCount: string | number,
  targetCount: string | number
) => {
  return isNanChecker(Math.round((+targetCount || 0) / (+commonCount / 100)));
};
